import React from 'react'
import { Link } from 'react-router-dom';

function Footer() {
    return (

        <div>
            <div className="rts-footer-area-one rts-section-gapTop">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="grid-lines-wrapper">
                                <div className="grid-lines">
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                    <div className="grid-line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row rts-section-gapBottom">
                        <div className="col-lg-12">
                            <div className="footer-main-wrapper-one">

                                <div className="footer-left-area">
                                    <a href="/" className="logo-footer">
                                        <img className="logo-1" src="assets/images/main-logo.png" alt="lolo-area" />
                                    </a>
                                    <p className="disc">
                                        Warmonks was born on a shared dream of a group<br /> of tech enthusiasts who came together to make<br /> use of the power of technology to create meaningful<br /> changes. Passion and a very clear vision did propel<br /> us and made our step toward building impactful digital<br /> solutions making life simplified and empowering a<br /> business to make the best out of it.
                                    </p>
                                    <div className="rts-social-area-one">
                                        <ul>
                                            <li><a href="https://www.facebook.com/profile.php?id=100075545787839" target='_blank'><i class="fa-brands fa-facebook-f"></i></a></li>
                                            <li><a href="https://www.instagram.com/team_warmonks/" target='_blank'><i class="fa-brands fa-instagram"></i></a></li>
                                            <li><a href="https://api.whatsapp.com/send?phone=919778544561&text=We%20welcome%20you%20to%20join%20us....%E2%98%BA%EF%B8%8F" target='_blank'><i class="fa-brands fa-whatsapp"></i></a></li>
                                            <li><a href="https://www.linkedin.com/company/warmonks/posts/?feedView=all" target='_blank'><i class="fa-brands fa-linkedin"></i></a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="footer-single-wized-start">
                                    <h5 className="title">Quick Links</h5>
                                    <ul className="footer-nav">
                                        <li><a href="/">Home</a></li>
                                        <li><a href="/about">About Us</a></li>
                                        <li><a href="/services">Services</a></li>
                                        <li><a href="/portfolio">Portfolio</a></li>
                                        <li><a href="/blogs">Blogs</a></li>
                                        <li><a href="/contact">Contact</a></li>
                                        <li><a href="/getaqute">Get a quote</a></li>
                                    </ul>
                                </div>

                                <div className="footer-single-wized-start">
                                    <h5 className="title">Our Services</h5>
                                    <ul className="footer-nav">
                                        <li><a href="#">Website Development</a></li>
                                        <li><a href="#">Mobile Application Development</a></li>
                                        <li><a href="#">Ecommerce Development</a></li>
                                        <li><a href="#">Digital Marketing</a></li>
                                        <li><a href="#">Search Engine Optimization</a></li>
                                        <li><a href="#">Graphic Designing</a></li>
                                    </ul>
                                </div>

                                <div className="footer-single-wized-start">
                                    <h5 className="title">Contact Info</h5>
                                    <div className="mail-contact-area">
                                        <div className="single-con-info mb--40">
                                            <a href="#">
                                                3rd Floor, SSS Plaza,<br /> Mahatma Nagar,<br /> Kizhakkumpattukara,<br /> Thrissur,
                                                Kerala 680005
                                            </a>
                                        </div>
                                        <div className="single-con-info mail">
                                            <a href="mailto:support@warmonks.com">
                                                support@warmonks.com
                                            </a>
                                        </div>
                                        <div className="single-con-info">
                                            <a href="tel:+91 9778544561">
                                                +91 9778544561
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright-area text-center">
                                <div className="left">
                                    <p>2025 © Warmonks. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
